import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./pages/home/home";
import ForgotPassword from "./pages/auth/ForgotPassword";
import VerificationCode from "./pages/auth/VerificationCode";
import CreateNewPassword from "./pages/auth/CreateNewPassword";
import PasswordResetComplete from "./pages/auth/PasswordResetComplete";
import AuthLayout from "./pages/auth/Layout";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import RegisterSuccess from "./pages/auth/RegisterSuccess";
import { ProtectedRoutes } from "./routes/ProtectedRoutes";
import Services from "./pages/services/Services";
import OurWorkDetail from "./pages/services/OurWorkDetail";
import Contact from "./pages/contact/Contact";
import Service from "./pages/services/Service";
import TermsOfService from "./pages/TermsOfService/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import StagesmartGPT from "./pages/services/StagesmartGPT";
import ThreeDRender from "./pages/services/ThreeDRender";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <ProtectedRoutes />
          <Routes>
            <Route path="/" element={<Navigate to="/auth/login" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/service/:id" element={<Service />} />
            <Route path="/3Dservices/:id" element={<ThreeDRender />} />
            <Route path="/services" element={<Services />} />
            <Route path="/stagesmart-gpt" element={<StagesmartGPT />} />
            <Route
              path="/our-work/:id/:serviceId"
              element={<OurWorkDetail />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="auth" element={<AuthLayout />}>
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="verify-account" element={<VerificationCode />} />
              <Route
                path="create-new-password"
                element={<CreateNewPassword />}
              />
              <Route
                path="password-reset-success"
                element={<PasswordResetComplete />}
              />
              <Route path="register-success" element={<RegisterSuccess />} />
            </Route>
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
